var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c(
            "div",
            { staticStyle: { height: "30px" } },
            [
              _c(
                "vxe-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "EXPORT",
                      expression: "`EXPORT`",
                    },
                  ],
                  attrs: { status: "primary" },
                  on: { click: _vm.export2Excel },
                },
                [_vm._v("导出")]
              ),
              _c(
                "vxe-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "BATCHAPPROVE",
                      expression: "`BATCHAPPROVE`",
                    },
                  ],
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.batchDialogVisible = true
                    },
                  },
                },
                [_vm._v("批量审批")]
              ),
              _c(
                "vxe-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "ASSIGN",
                      expression: "`ASSIGN`",
                    },
                  ],
                  attrs: { type: "warning" },
                  on: { click: _vm.handleTransfer },
                },
                [_vm._v("指派")]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    float: "right",
                    color: "#848484",
                    display: "flex",
                    "line-height": "28px",
                  },
                },
                [
                  !_vm.showFilter
                    ? _c(
                        "div",
                        { staticStyle: { float: "right", display: "flex" } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: {
                                "margin-right": "1rem",
                                width: "240px",
                              },
                              attrs: {
                                placeholder: "请选择经理部",
                                mode: "multiple",
                                maxTagCount: 2,
                                "filter-option": false,
                              },
                              model: {
                                value: _vm.queryCondition.regionIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "regionIds", $$v)
                                },
                                expression: "queryCondition.regionIds",
                              },
                            },
                            _vm._l(_vm.sectorList, function (item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.sectorId,
                                  attrs: { value: item.sectorId },
                                },
                                [_vm._v(" " + _vm._s(item.sectorName) + " ")]
                              )
                            }),
                            1
                          ),
                          _c("a-input", {
                            staticStyle: {
                              width: "200px",
                              "margin-right": "1rem",
                              height: "28px",
                            },
                            attrs: {
                              placeholder: "请输入提报名称/提报编码",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.queryByPage(1)
                              },
                            },
                            model: {
                              value: _vm.queryCondition.applyNameOrCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "applyNameOrCode",
                                  $$v
                                )
                              },
                              expression: "queryCondition.applyNameOrCode",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    [
                      !_vm.showFilter
                        ? _c(
                            "vxe-button",
                            {
                              attrs: { status: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.queryByPage(1)
                                },
                              },
                            },
                            [_vm._v("搜索")]
                          )
                        : _vm._e(),
                      !_vm.showFilter
                        ? _c(
                            "vxe-button",
                            {
                              staticClass: "filter-search-item",
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm(1)
                                },
                              },
                            },
                            [_vm._v("重置")]
                          )
                        : _vm._e(),
                      _c(
                        "vxe-button",
                        { attrs: { type: "warning" }, on: { click: _vm.cb } },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.showFilter ? "收起" : "筛选") + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showFilter,
                        expression: "showFilter",
                      },
                    ],
                  },
                  [
                    _c("SiftReimburse", {
                      attrs: {
                        data: _vm.queryCondition,
                        "sift-type": "apply",
                        "sector-list": _vm.sectorList,
                      },
                      on: {
                        "update:data": function ($event) {
                          _vm.queryCondition = $event
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "padding-bottom": "10px",
                          "margin-bottom": "10px",
                        },
                        attrs: { slot: "footer" },
                        slot: "footer",
                      },
                      [
                        _c(
                          "vxe-button",
                          {
                            attrs: { type: "info" },
                            on: {
                              click: function ($event) {
                                return _vm.resetForm(1)
                              },
                            },
                          },
                          [_vm._v("重置")]
                        ),
                        _c(
                          "vxe-button",
                          {
                            attrs: { status: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.queryByPage(1)
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("vxe-toolbar", {
            ref: "toolbarRef",
            staticStyle: {
              height: "39px",
              "margin-top": "-10px",
              background: "#F3F4F7",
            },
            attrs: { custom: "" },
          }),
          _c(
            "vxe-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "xTable",
              staticClass: "mytable-scrollbar",
              attrs: {
                id: "toolbar_signindex",
                "max-height":
                  _vm.$store.state.app.height - 130 < 500
                    ? 500
                    : _vm.$store.state.app.height - 130,
                border: "",
                align: "center",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                "custom-config": {
                  storage: true,
                  checkMethod: _vm.checkColumnMethod,
                },
                "scroll-y": { enabled: false },
                "row-config": { isCurrent: true, isHover: true },
                data: _vm.tableData,
              },
              on: { "cell-dblclick": _vm.cellClickEvent },
            },
            [
              _c("vxe-column", {
                attrs: { type: "checkbox", width: "60", align: "center" },
              }),
              _c("vxe-column", {
                attrs: {
                  visible: false,
                  title: "id",
                  field: "id",
                  width: "100",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  type: "seq",
                  title: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  visible: false,
                  title: "活动计划编码",
                  field: "planCode",
                  width: "120",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "活动提报编码",
                  field: "planApplyCode",
                  width: "120",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "经理部名称",
                  field: "regionName",
                  width: "120",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  visible: false,
                  title: "经销商名称",
                  field: "dealerName",
                  width: "200",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "经销商名称",
                  field: "dealerShortName",
                  width: "200",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "申请人",
                  field: "createUserName",
                  width: "100",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "活动提报名称",
                  field: "planApplyName",
                  width: "150",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "预算类型",
                  field: "budgetTypeName",
                  width: "120",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "一级来源",
                  field: "oneLevelName",
                  width: "120",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "二级来源",
                  field: "twoLevelName",
                  width: "120",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "三级来源",
                  field: "threeLevelName",
                  width: "120",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "计划开始时间",
                  field: "planStartTime",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateFormat")(
                                row.planStartTime,
                                "yyyy-MM-dd"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  title: "计划结束时间",
                  field: "planEndTime",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateFormat")(
                                row.planEndTime,
                                "yyyy-MM-dd"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  visible: false,
                  title: "提报时间",
                  field: "applyTime",
                  width: "160",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "发起时间",
                  field: "applyFlowStart",
                  width: "160",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "活动预算(元)",
                  field: "totalCost",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("toThousandNumFilter")(row.totalCost)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  title: "品系",
                  field: "strainsNameList",
                  width: "200",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "车型代码",
                  field: "vehicleCodeList",
                  width: "200",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "提报审批金额（元）",
                  field: "approveApplyCost",
                  width: "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.approveApplyCost
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toThousandNumFilter")(
                                    row.approveApplyCost
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  title: "当前审批节点",
                  field: "applyNode",
                  width: "160",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "当前节点审批人",
                  field: "applyAuditorNames",
                  width: "160",
                },
              }),
              _c("vxe-column", {
                attrs: {
                  visible: false,
                  title: "当前节点审批人ids",
                  field: "applyAuditorIds",
                  width: "160",
                },
              }),
              _c("vxe-column", {
                attrs: { field: "name", title: "集客二维码", width: "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "handle-box" },
                          [
                            _c(
                              "a-button",
                              {
                                attrs: { type: "link" },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadImage(
                                      row.planApplyCode,
                                      row.planApplyCode + "二维码"
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 下载 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  title: "提报状态",
                  field: "applyStatus",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.applyStatus === "0"
                          ? _c("span", [_vm._v("填报中")])
                          : _vm._e(),
                        row.applyStatus === "1"
                          ? _c("span", [_vm._v("审批中")])
                          : _vm._e(),
                        row.applyStatus === "2"
                          ? _c("span", [_vm._v("审批通过")])
                          : _vm._e(),
                        row.applyStatus === "3"
                          ? _c("span", [_vm._v("已驳回")])
                          : _vm._e(),
                        row.applyStatus === "4"
                          ? _c("span", [_vm._v("不通过")])
                          : _vm._e(),
                        row.applyStatus === "5"
                          ? _c("span", [_vm._v("调整中")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: {
                  field: "address",
                  title: "操作",
                  width: "380",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "handle-box" },
                          [
                            +row.applyStatus != 0
                              ? _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link", status: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewApproveDetail(row)
                                      },
                                    },
                                  },
                                  [_vm._v("审核流程")]
                                )
                              : _vm._e(),
                            _c(
                              "a-button",
                              {
                                directives: [
                                  {
                                    name: "auth",
                                    rawName: "v-auth",
                                    value: "VIEW",
                                    expression: "`VIEW`",
                                  },
                                ],
                                attrs: { type: "link", status: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.queryRow(row)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                            _vm.domain === "dealer" &&
                            (+row.applyStatus == 0 || +row.applyStatus == 3)
                              ? _c(
                                  "a-button",
                                  {
                                    directives: [
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value: "UPDATE",
                                        expression: "`UPDATE`",
                                      },
                                    ],
                                    attrs: { status: "primary", type: "link" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.updateRow(row)
                                      },
                                    },
                                  },
                                  [_vm._v("修改")]
                                )
                              : _vm._e(),
                            _vm.domain === "dealer" &&
                            (row.applyStatus === "0" || row.applyStatus === "3")
                              ? _c(
                                  "a-button",
                                  {
                                    directives: [
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value: "PROCESS",
                                        expression: "`PROCESS`",
                                      },
                                    ],
                                    attrs: { status: "primary", type: "link" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.startApprove(row)
                                      },
                                    },
                                  },
                                  [_vm._v("发起审批")]
                                )
                              : _vm._e(),
                            _vm.domain === "dealer" &&
                            (row.applyStatus === "0" || row.applyStatus === "3")
                              ? _c(
                                  "a-button",
                                  {
                                    directives: [
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value: "DELETE",
                                        expression: "`DELETE`",
                                      },
                                    ],
                                    attrs: { status: "primary", type: "link" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteRow(row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.listLoading,
                expression: "!listLoading",
              },
            ],
            attrs: {
              "current-page": _vm.pagination.current,
              "page-size": _vm.pagination.size,
              total: _vm.pagination.total,
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.changePage },
          }),
          _c("vxe-modal", {
            attrs: {
              title: "查看详情",
              width: "600",
              height: "400",
              mask: false,
              "lock-view": false,
              resize: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [
                    _c(
                      "vxe-table",
                      {
                        attrs: {
                          border: "inner",
                          "auto-resize": "",
                          "show-overflow": "",
                          height: "auto",
                          "row-config": { isHover: true },
                          "show-header": false,
                          "sync-resize": _vm.showDetails,
                          data: _vm.detailData,
                        },
                      },
                      [
                        _c("vxe-column", {
                          attrs: { field: "label", width: "40%" },
                        }),
                        _c("vxe-column", { attrs: { field: "value" } }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.showDetails,
              callback: function ($$v) {
                _vm.showDetails = $$v
              },
              expression: "showDetails",
            },
          }),
          _c(
            "a-modal",
            {
              staticClass: "demo-addForm",
              attrs: {
                title: "活动提报",
                visible: _vm.addSignInVisibleOne,
                width: "70%",
                footer: false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.addSignInVisibleOne = $event
                },
                close: _vm.handleClose,
                cancel: function ($event) {
                  _vm.addSignInVisibleOne = false
                },
              },
            },
            [
              _c("SiftActivity", {
                attrs: { data: _vm.addCondition, show: false },
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "margin-bottom": "10px",
                  },
                },
                [
                  _c(
                    "vxe-button",
                    {
                      attrs: { size: "small", status: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.getActPlans(1)
                        },
                      },
                    },
                    [_vm._v("搜索")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      staticClass: "filter-search-item",
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.resetForm(2)
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
              _c(
                "vxe-table",
                {
                  ref: "xRole",
                  attrs: {
                    border: "",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "column-config": { resizable: true },
                    stripe: "",
                    round: "",
                    loading: _vm.addLoading,
                    "max-height": "370",
                    align: "center",
                    "scroll-y": { enabled: false },
                    data: _vm.actPlanList,
                    reserve: true,
                    "row-config": { isCurrent: true, isHover: true },
                    "radio-config": {
                      strict: false,
                      labelField: "name",
                      trigger: "row",
                      isCurrent: true,
                      isHover: true,
                    },
                  },
                },
                [
                  _c("vxe-column", {
                    attrs: { type: "checkbox", width: "60", align: "center" },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      type: "seq",
                      title: "序号",
                      width: "60",
                      align: "center",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "actName",
                      title: "活动名称",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "planCode",
                      title: "活动计划编码",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "releaseTime",
                      title: "发布时间",
                      width: "150",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "planStartTime",
                      title: "计划开始时间",
                      width: "120",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "planEndTime",
                      title: "计划结束时间",
                      width: "120",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "oneLevelName",
                      title: "一级来源",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "twoLevelName",
                      title: "二级来源",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "threeLevelName",
                      title: "三级来源",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "budgetTypeName",
                      title: "预算类型",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "createTime",
                      title: "创建时间",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "createUserName",
                      title: "创建人",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "feeLimit",
                      title: "费用额度(元)",
                      width: "160",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("toThousandNumFilter")(row.feeLimit)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "writeRate",
                      title: "核销比例(%)",
                      width: "120",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "executeFreq",
                      title: "执行频次",
                      width: "120",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "remainFreq",
                      title: "剩余执行频次",
                      width: "120",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "customerTarget",
                      title: "集客目标",
                      width: "120",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "orderTarget",
                      title: "订单目标",
                      width: "120",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "executeNums",
                      title: "执行数量",
                      width: "120",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "closeTime",
                      title: "关闭时间",
                      width: "130",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "remarks",
                      title: "活动其他说明",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "writeOffRules",
                      title: "核销规则",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "writeOffMaterial",
                      title: "核销材料说明",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "writeOffOther",
                      title: "核销其他说明",
                      width: "160",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "操作",
                      width: "150",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              { staticClass: "handle-box" },
                              [
                                _c(
                                  "vxe-button",
                                  {
                                    attrs: { size: "small", status: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.signSubmit(row, 1)
                                      },
                                    },
                                  },
                                  [_vm._v("追加")]
                                ),
                                _c(
                                  "vxe-button",
                                  {
                                    attrs: { size: "small", status: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.signSubmit(row, 0)
                                      },
                                    },
                                  },
                                  [_vm._v("提报")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("vxe-pager", {
                attrs: {
                  loading: _vm.listLoading,
                  "current-page": _vm.addTablePage.current,
                  "page-size": _vm.addTablePage.size,
                  total: _vm.addTablePage.total,
                  layouts: [
                    "PrevPage",
                    "JumpNumber",
                    "NextPage",
                    "FullJump",
                    "Sizes",
                    "Total",
                  ],
                },
                on: { "page-change": _vm.handleAddPageChange },
              }),
            ],
            1
          ),
          _c(
            "a-modal",
            {
              attrs: {
                title: "审批信息",
                visible: _vm.transdialogVisible,
                width: "40%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.transdialogVisible = $event
                },
                cancel: function ($event) {
                  _vm.transdialogVisible = false
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "demo-input-suffix",
                  staticStyle: { "padding-bottom": "20px" },
                },
                [
                  _vm._v(" 转派人： "),
                  _c("el-input", {
                    staticStyle: { width: "35%" },
                    attrs: { placeholder: "请选择转派的用户" },
                    on: { focus: _vm.chooseUser },
                    model: {
                      value: _vm.operatorUser,
                      callback: function ($$v) {
                        _vm.operatorUser = $$v
                      },
                      expression: "operatorUser",
                    },
                  }),
                ],
                1
              ),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入审批意见",
                  maxlength: "300",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.approveMsg,
                  callback: function ($$v) {
                    _vm.approveMsg = $$v
                  },
                  expression: "approveMsg",
                },
              }),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "vxe-button",
                    {
                      attrs: {
                        loading: _vm.TransferApproveBtnLoading,
                        status: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.transferApprove()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.transdialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "选择导出项",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            cancel: function ($event) {
              _vm.dialogVisible = false
            },
          },
        },
        [
          _c(
            "a-radio-group",
            {
              staticStyle: { "margin-bottom": "20px" },
              model: {
                value: _vm.ExportType,
                callback: function ($$v) {
                  _vm.ExportType = $$v
                },
                expression: "ExportType",
              },
            },
            [
              _c("a-radio", { attrs: { value: 0 } }, [_vm._v("基础数据")]),
              _c("a-radio", { attrs: { value: 1 } }, [_vm._v("详细数据")]),
            ],
            1
          ),
          _c(
            "a-radio-group",
            {
              model: {
                value: _vm.ExportItem,
                callback: function ($$v) {
                  _vm.ExportItem = $$v
                },
                expression: "ExportItem",
              },
            },
            [
              _c("a-radio", { attrs: { value: 0 } }, [_vm._v("导出全部")]),
              _c("a-radio", { attrs: { value: 1 } }, [_vm._v("导出当前页")]),
              _c("a-radio", { attrs: { value: 2, disabled: _vm.disabled } }, [
                _vm._v("导出已选择项"),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: {
                    status: "primary",
                    loading: _vm.outExcelButtonLocading,
                  },
                  on: { click: _vm.outExcel },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.taskDialogVisible,
            width: "80%",
            footer: null,
          },
          on: {
            "update:visible": function ($event) {
              _vm.taskDialogVisible = $event
            },
            cancel: function ($event) {
              _vm.taskDialogVisible = false
            },
          },
        },
        [
          _c(
            "vxe-table",
            {
              ref: "xApprove",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.approveLoading,
                "max-height": "370",
                align: "center",
                "scroll-y": { enabled: false },
                data: _vm.taskListData,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
              },
            },
            [
              _c("vxe-column", {
                attrs: { type: "seq", title: "序号", width: "60" },
              }),
              _c("vxe-column", {
                attrs: { field: "displayName", title: "节点名称" },
              }),
              _c("vxe-column", {
                attrs: { field: "operatorName", title: "审批人" },
              }),
              _c("vxe-column", {
                attrs: { field: "operateType", title: "操作类型" },
              }),
              _c("vxe-column", {
                attrs: { field: "approveCost", title: "审核金额" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.approveCost
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("toThousandNumFilter")(
                                      row.approveCost
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: { field: "approveMsg", title: "审批意见" },
              }),
              _c("vxe-column", {
                attrs: { field: "finishTime", title: "处理时间" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.appdialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.appdialogVisible = $event
            },
            cancel: function ($event) {
              _vm.appdialogVisible = false
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            model: {
              value: _vm.approveMsg,
              callback: function ($$v) {
                _vm.approveMsg = $$v
              },
              expression: "approveMsg",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary", loading: _vm.approveBtnLoading },
                  on: {
                    click: function ($event) {
                      return _vm.approve()
                    },
                  },
                },
                [_vm._v("发起审批")]
              ),
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.appdialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "批量审批信息",
            visible: _vm.batchDialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchDialogVisible = $event
            },
            cancel: function ($event) {
              _vm.batchDialogVisible = false
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            model: {
              value: _vm.batchApproveMsg,
              callback: function ($$v) {
                _vm.batchApproveMsg = $$v
              },
              expression: "batchApproveMsg",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary", loading: _vm.approveBtnLoading },
                  on: {
                    click: function ($event) {
                      return _vm.approveBatch()
                    },
                  },
                },
                [_vm._v("同意")]
              ),
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.batchDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择用户",
            visible: _vm.userDialogVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.userDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("el-input", {
                style: { width: "80%" },
                attrs: { placeholder: "输入用户名称", clearable: "" },
                on: { change: _vm.handleFilter },
                model: {
                  value: _vm.userName,
                  callback: function ($$v) {
                    _vm.userName = $$v
                  },
                  expression: "userName",
                },
              }),
              _c(
                "vxe-button",
                {
                  staticClass: "filter-search-item",
                  staticStyle: { float: "right" },
                  attrs: { status: "primary" },
                  on: { click: _vm.handleFilter },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
          _c(
            "vxe-table",
            {
              ref: "Xuser",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.userLoading,
                "max-height": "350",
                align: "center",
                "scroll-y": { enabled: false },
                data: _vm.userLists,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
                "radio-config": {
                  strict: false,
                  labelField: "seq",
                  trigger: "row",
                  isCurrent: true,
                  isHover: true,
                },
              },
            },
            [
              _c("vxe-column", { attrs: { type: "radio", width: "60" } }),
              _c("vxe-column", {
                attrs: { visible: false, field: "id", title: "用户id" },
              }),
              _c("vxe-column", {
                attrs: { type: "seq", title: "序号", width: "60" },
              }),
              _c("vxe-column", {
                attrs: { field: "name", title: "用户名称", width: "110" },
              }),
              _c("vxe-column", {
                attrs: { field: "department", title: "所属组织结构" },
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            attrs: {
              loading: _vm.userLoading,
              "current-page": _vm.userTablePage.currentPage,
              "page-size": _vm.userTablePage.pageSize,
              total: _vm.userTablePage.totalResult,
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.handlePageChange },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.userDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleChooseUser()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "发起流程",
            visible: _vm.approveDialog,
            width: "25%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approveDialog = $event
            },
            cancel: function ($event) {
              _vm.approveDialog = false
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "demo-input-suffix" },
            [
              _vm._v(" 意见栏： "),
              _c("el-input", {
                attrs: { placeholder: "请输入内容" },
                model: {
                  value: _vm.approveMsg,
                  callback: function ($$v) {
                    _vm.approveMsg = $$v
                  },
                  expression: "approveMsg",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.approveDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: { click: _vm.confirmStart },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "提报审核流程",
            visible: _vm.checkFlowShow,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.checkFlowShow = $event
            },
            cancel: function ($event) {
              _vm.checkFlowShow = false
            },
          },
        },
        [_c("checkFlow", { attrs: { data: _vm.budgetData } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }